// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/error-boundaries */
import Wistia, { getWistiaProps } from './Wistia';
import Youtube, { getYoutubeProps } from './Youtube';

interface EmbedProps {
  className?: string;
  embedCode: string;
}

export default function Embed({ className, embedCode }: EmbedProps) {
  try {
    if (embedCode.toLowerCase().startsWith('<youtube')) {
      return <Youtube {...getYoutubeProps(embedCode)} />;
    }
    if (embedCode.toLowerCase().startsWith('<wistia')) {
      return <Wistia {...getWistiaProps(embedCode)} />;
    }

    return <div className={className} suppressHydrationWarning dangerouslySetInnerHTML={{ __html: embedCode }} />;
  } catch (e) {
    console.error('Error rendering embed', e);
    return <div className={className}>Embed error</div>;
  }
}
